import React from 'react';
import { Button, Pane, PropertyGrid, TextInput } from '@leverege/ui-elements';
import classNames from 'classnames';
import S from './ComponentTypesEditor.css';
function ComponentTypesEditor(props) {
  const {
    attr,
    onChange,
    data
  } = props;
  const value = attr?.get(data) || [];

  // value should look like:
  // [ { type, name }, ... ]

  const valueChange = ({
    data,
    value: evtValue
  }) => {
    const {
      item,
      index,
      field
    } = data;
    const newValue = [...value];
    newValue[index] = {
      ...item,
      [field]: evtValue
    };
    onChange({
      data: {
        attribute: attr
      },
      value: newValue
    });
  };
  const addNew = () => {
    const newValue = [...value];
    newValue.push({});
    onChange({
      data: {
        attribute: attr
      },
      value: newValue
    });
  };
  const removeIndex = ({
    data: {
      index
    }
  }) => {
    const newValue = value.filter((val, i) => i !== index);
    onChange({
      data: {
        attribute: attr
      },
      value: newValue
    });
  };
  return /*#__PURE__*/React.createElement(Pane, null, value?.map((item, index) => {
    const {
      type,
      name
    } = item || {};
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(Pane, {
        key: `${type}-${index}`,
        className: classNames(S.bottom, S.win),
        layout: "flex:row"
      }, /*#__PURE__*/React.createElement(PropertyGrid, {
        className: S.grow,
        vertical: true,
        columns: 2
      }, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
        label: "Type"
      }, /*#__PURE__*/React.createElement(TextInput, {
        onChange: valueChange,
        eventData: {
          item,
          index,
          field: 'type'
        },
        value: type
      })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
        label: "Name"
      }, /*#__PURE__*/React.createElement(TextInput, {
        onChange: valueChange,
        eventData: {
          item,
          index,
          field: 'name'
        },
        value: name
      }))), /*#__PURE__*/React.createElement(Button, {
        className: S.padBottom,
        variant: "link",
        onClick: removeIndex,
        icon: "fa fa-trash-o",
        eventData: {
          index
        }
      }))
    );
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    icon: "fa fa-plus",
    onClick: addNew
  }));
}
const type = 'componentTypes';
export default {
  type,
  editor: ComponentTypesEditor
};